import React from 'react';
// import PropTypes from 'prop-types';
import $ from "jquery";
import canvasToimage from "./canvas2image";
import { Button, Spin, message } from 'antd';
import './index.scss';

let Canvas2Image = canvasToimage();

/**
 *  INFO: 上传逻辑在Components/Comment组件中的uploadImg方法内
 */

class CanvasComponent extends React.Component {

    constructor(props) {
        super(props);

        this.ctx = '';
        this.mousePressed = false;
        this.lastX = '';
        this.lastY = '';
        this.compressMaxWidth = 750;                               // 图片压缩的最大宽度，小于的话则不进行压缩
        this.state = {
            imgLoading: false,                                     // 图片
        };
        this.step = -1;                                            // 当前记录位置
        this.canvasHistory = [];                                   // 历史数据数组
        this.stepLength = 5;                                       // 撤销以及反撤销的步长
        this.lastSaveTime = 0;                                     // 上次保存的时间
        this.img = null;
        this.rotateAngle = 0;                                      // 旋转角度
        this.even = true;                                          // 是否旋转偶数次
        this.textMode = 0;
        this.para = null;
        this.scale = 1.3;                                            // 图片放大倍数
    }

    componentDidMount() {
        // this.getImgFileSize();
        let that = this;
        this.ctx = document.getElementById('myCanvas').getContext("2d");
        $('#myCanvas').mousedown(function(e) {
          if (that.textMode > 0) {
            if (that.step === -1) {
                that.saveHistory()
            }
            if (that.textMode === 1) {//开始打字
              that.createTxtArea(e)
            }else if(that.textMode === 2){
              that.para.attr({'contenteditable': false, 'draggable': true})
              that.para.css({'cursor': 'move'})
            }
          }else {
            that.mousePressed = true;
            that.Draw(e.pageX - $(this).offset().left, e.pageY - $(this).offset().top, 'mousedown');
          }
        });

        $('#myCanvas').mousemove(function(e) {
            if (that.mousePressed) {
                that.Draw(e.pageX - $(this).offset().left, e.pageY - $(this).offset().top, 'mousemove');
            }
        });

        $('#myCanvas').mouseup((e) => {
          if (that.textMode === 0) {
            that.Draw(0, 0, 'mouseup');
            this.mousePressed = false;
          }
        });
        $('#myCanvas').mouseleave((e) => {
            this.mousePressed = false;
        });

  			$("div.canvas-container").on("dragstart", 'p.txt_area', (e) => {
          this.canvasTxtLoc['dragstart'] = {'offsetY': e.offsetY, 'offsetX': e.offsetX}
  			})

        $("div.canvas-container").on("dragend", 'p.txt_area', function(e){
          let moveX = e.offsetX - that.canvasTxtLoc['dragstart'].offsetX
          let moveY = e.offsetY - that.canvasTxtLoc['dragstart'].offsetY
          that.canvasTxtLoc.offsetY = that.canvasTxtLoc.offsetY + moveY
          that.canvasTxtLoc.offsetX = that.canvasTxtLoc.offsetX + moveX
          that.canvasTxtLoc.width = (that.canvasTxtLoc.canvasWidth-that.canvasTxtLoc.offsetX);

          $(this).css({'top': that.canvasTxtLoc.offsetY+'px', 'left': that.canvasTxtLoc.offsetX})
  			})

        $('div.canvas-container').on('dblclick', 'p.txt_area', function() {
          $(this).attr({'contenteditable': true, 'draggable': false})
          $(this).css({'cursor': 'text'})
          $(this).focus()
        })

        if (this.props.imgUrl.startsWith('http')) {
          let src = this.props.imgUrl+`?${this.randomStr()}`;
          this.canvasDrawImage(src);
        }else {
          this.canvasDrawImage(this.props.imgUrl);
        }
    }

    /** 图片超过800kb，需要放大canv和图片，内容才不会模糊
     * 有跨域，需要把跨域打开
     */
    getImgFileSize = () => {
        let that = this;
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("HEAD", this.props.imgUrl);
        xmlhttp.send();
        xmlhttp.onload = function () {
            if (xmlhttp.status == 200) {
                let size = xmlhttp.getResponseHeader('Content-Length') / 1000;
                // console.log('size', size);
                if(size>800) {
                    that.scale = 1.4;
                }
            }
        }
    }

    createTxtArea = async (e) => {
      this.para = $('<p class="txt_area" contenteditable="true"></p>')
      this.para.css({
        'position': 'absolute',
        'top': e.offsetY+'px',
        'left': e.offsetX+'px',
        'border': '1px solid red',
        'font-size': ($('#selFont').val()-2)+'px',
        'color': 'red',
        'padding': '3px',
      })
      $('#myCanvas').after(this.para)
      setTimeout(()=>{
        this.para.focus();
      }, 300)

      this.canvasTxtLoc = {
        offsetX: e.offsetX,
        offsetY: e.offsetY,
        canvasWidth: e.target.clientWidth,
        width: e.target.clientWidth-e.offsetX
      }; //缓存文字记录


      this.textMode = 2 // 创建输入框
    }

    renderTxt = () => {
      let that = this;
      if (!that.para) {
        return ;
      }
      $('.txt_area style').remove()
      // 绘制文字
      let content = that.para.html()

      content = content.replace(/(<div>)|(<\/div>)/g, '<bl>').split("<bl>");
      content = content.filter(i => i.length > 0)

      that.para.hide()
      let countY = 0;
      that.ctx.font= $('#selFont').val()+"px Arial";
      that.ctx.fillStyle='red';
      // content && $(content).forEach(i => {
      content && content.forEach(function (i) {
          var txt = i === '<br>' ? '' : $('<div/>').html(i.trim()).text();

          let arrText = txt.split('');
          var line = '';
          // 逐行显示，避免canvas文字绘制溢出
          arrText.forEach((ele, n) => {
            var testLine = line + ele;
            var metrics = that.ctx.measureText(testLine);
            if (metrics.width > that.canvasTxtLoc.width && n > 0) {
                that.ctx.fillText(line, that.canvasTxtLoc.offsetX, that.canvasTxtLoc.offsetY + 20 + countY * 22);
                line = ele;
                countY++
            } else {
                line = testLine;
            }
          })

          if (line.length>0) {
            that.ctx.fillText(line, that.canvasTxtLoc.offsetX, that.canvasTxtLoc.offsetY + 20 + countY * 22);
            countY++
          }

      })

      // content && content.forEach((i, idx) => {
      //   let txt = i==='<br>'?'':$('<div/>').html(i).text();
      //   that.ctx.fillText(txt, that.canvasTxtLoc.offsetX, that.canvasTxtLoc.offsetY + 20 + idx * 22);
      // })
      that.para = null;
      // 每次绘制完都应该保存一次
      that.saveHistory();
    }

    /** canvasDrawImage */
    canvasDrawImage = src => {
        let that = this;
        let curWidth = this.even ? this.props.imgWidth : this.props.imgHeight;
        let curHeight = this.even ? this.props.imgHeight : this.props.imgWidth;
        this.ctx.clearRect(0, 0, curWidth, curHeight);
        let img = new Image();
        img.setAttribute('crossOrigin','anonymous');
        img.src = src;
        this.setState({ imgLoading: true });
        img.width = curWidth * this.scale;
        img.height = curHeight * this.scale;
        img.onload = function() {
            that.setState({ imgLoading: false });
            that.ctx.drawImage(img, 0, 0, img.width, img.height);
        };
        this.img = img;
    }

    /** 生成随机字符串拼接在图片上面，使得图片进行强制更新 */
    randomStr = () => {
        let num1 = Math.random();
        let num2 = Math.random();
        let num3 = Math.random();

        return '' + num1 + num2 + num3;
    }

    Draw = (x, y, status) => {
        // 正在加载时不允许绘制
        if (this.state.imgLoading) {
            return;
        }
        // 第一次绘制时记录初始快照
        if (this.step === -1 && status === 'mousedown') {
            this.saveHistory()
        }

        if (status === 'mousemove') {
            this.ctx.beginPath();
            this.ctx.strokeStyle = $('#selColor').val();
            this.ctx.lineWidth = $('#selWidth').val();
            this.ctx.lineJoin = "round";
            this.ctx.moveTo(this.lastX, this.lastY);
            this.ctx.lineTo(x, y);
            this.ctx.closePath();
            this.ctx.stroke();
        }
        if (status !== 'mouseup') {
            this.lastX = x;
            this.lastY = y;
        } else {
            // 每调用一次绘制操作，都把当前的快照存储到历史记录中，很费性能
            // 只在每一次操作结束时记录快照
            this.saveHistory()
        }
    }

    saveHistory = () => {
      this.step++;
      if (this.step < this.canvasHistory.length) {
          this.canvasHistory.length = this.step;
      }
      this.canvasHistory.push(this.refs.canvasInstance.toDataURL());
    }

    clearArea = () => {
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    }

    /** 点击保存图片到本地 */
    generatePic = () => {
        let canvas = this.refs.canvasInstance;
        Canvas2Image.saveAsPNG(canvas);                     // 保存的png格式，注意一下
    }

    /** 点击上传图片按钮 */
    uploadHandler = () => {
        this.renderTxt()
        /** 文件名就采用img链接进行改造，确保客户端所上传的img链接是正确的路径命名方法 */
        let url = this.props.imgUrl;
        if (Object.prototype.toString.call(url) != '[object String]') {
            console.error('图片链接不是一个string类型');
            return;
        }

        // let fileName = ``, endIndex;
        // let beginIndex = url.indexOf('.com/');
        // fileName = url.slice(beginIndex+'.com/'.length);
        // if (fileName.indexOf('feedback') !== -1) {
        //     fileName = fileName.replace('.jpg', '.png');
        //     fileName = fileName.replace('.jpeg', '.png');
        //     fileName = fileName.replace('.gif', '.png');
        //     fileName = fileName.split('?')[0];
        // } else {
        //     endIndex = fileName.indexOf('.');
        //     fileName = fileName.substr(0, endIndex)+'-feedback';
        //     fileName += '.png';
        // }
        let fileName = this.props.imgKey.split('-feedback')[0] + '-feedback-' + new Date().getTime()+'.png'

        // LOG：下面的压缩方法并没有用，画不了图片到canvas上面，有可能是因为跨域
        // let originPng = Canvas2Image.convertToPNG(this.refs.canvasInstance, this.props.imgWidth, this.props.imgHeight);
        // originPng.setAttribute('crossOrigin','anonymous');
        // let compressedPng = this.compressPng(originPng, this.props.imgWidth, this.props.imgHeight, 0.8);
        // let downLoad = (url) => {
        //     var oA = document.createElement("a");
        //     oA.download = '';// 设置下载的文件名，默认是'下载'
        //     oA.href = url;
        //     document.body.appendChild(oA);
        //     oA.click();
        //     oA.remove(); // 下载之后把创建的元素删除
        // };

        let compressedPng = this.refs.canvasInstance.toDataURL('image/png');
        let blob = this.dataUrl2Blob(compressedPng);
        let file = this.blob2File(blob, fileName);
        // downLoad(compressedPng);
        let cb = () => {
            this.props.hideCanvasComponent();
        };
        let cacheName = `canvas${this.props.answerId}`;
        if (!window[cacheName]) {
            window[cacheName] = {};
        }else {
          let keys = Object.keys(window[cacheName])
          let fileNamePrefix = fileName.split('.')[0].split('-feedback')[0];
          keys.filter(i => i.split('-feedback')[0] === fileNamePrefix).forEach(i=>{
            delete window[cacheName][i]
          })
        }

        // 将涂鸦的图片缓存在 window 对象下，等待提交点评时上传
        window[cacheName][fileName] = {
            fileName,
            file,
            cb
        };
        this.props.hideCanvasComponent();
        this.props.showHoldImg({
            fileName: fileName.split('-feedback')[0],
            compressedPng
        });
        // this.props.upload(fileName, file, cb);
    }

    /** 点击关闭按钮 */
    closeCanvasComponent = () => {
        let makeSure = window.confirm('关闭将会丢失您未保存的批注记录');
        if (makeSure == true) {                            // 点击确定，进行数据保存
            // this.uploadHandler();
            this.props.hideCanvasComponent();
        } else {                                           // 点击取消的话，什么都不做
            // this.props.hideCanvasComponent();
        }
    }

    /** 压缩图片方法, img可以是dataUrl 或者是 URL */
    // compressPng = (img, width, height, radio) => {
    //     if (width > this.compressMaxWidth) {                // 需要先进行缩放处理
    //         radio = width / height;
    //         width = this.compressMaxWidth;
    //         height = this.compressMaxWidth * radio;
    //     }
    //     let canvas, ctx, img64;
    //     canvas = document.createElement('canvas');
    //     canvas.width = width;
    //     canvas.height = height;

    //     ctx = canvas.getContext('2d');
    //     ctx.drawImage(img, 0, 0, width, height);
    //     document.body.appendChild(canvas);

    //     img64 = canvas.toDataURL('image/png', radio);      // 压缩后的图片生成base64的dataUrl

    //     return img64;
    // }

    /** 将用dataUrl所表示图片转换成blob格式的对象数据 */
    dataUrl2Blob = dataUrl => {
        let arr = dataUrl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }

    /** 将blob数据格式转换成file */
    blob2File = (blobData, fileName) => {
        let file = new File([blobData], fileName, { lastModified: Date.now(), lastModifiedDate: new Date(), type: "image/png", name: fileName });
        return file;
    }

    /** 撤销方法 */
    undo = () => {
        if (this.step > 0) {
            this.step--;
            /** 清空画布重新画，会有性能问题 */

            let src = this.canvasHistory[this.step];
            this.canvasDrawImage(src);

        } else {
            message.info('已经到了最后一步了，不能再接着撤销了');
        }
    }

    /** 反撤销方法 */
    redo = () => {
        if (this.step < this.canvasHistory.length - 1) {
            this.step++;

            let src = this.canvasHistory[this.step];
            this.canvasDrawImage(src);

        } else {
            message.info('已经到了最新记录了，不能再接着返回了');
        }
    }

    rotateWrapper = (isAdd) => {
        this.props.w2h(() => this.rotate(isAdd));
    }

    text = (stop) => {
      // 关闭文字编辑，切换到画笔模式
      if (stop) {
        this.renderTxt()
        this.textMode = 0;
      }else if (this.textMode === 0) {
        this.textMode = 1;
      }else if (this.textMode === 2) {
        this.renderTxt()
        this.textMode = 1;
      }
    }

    /** 旋转方法 */
    rotate = (isAdd=true) => {
        let makeSure = window.confirm('旋转将会清空已有绘制内容');
        if (!makeSure) {                            // 点击取消，什么都不做
            return
        }
        this.clearArea();                                   // 在旋转之前先删除当前绘制
        // 旋转后不允许回退，因为之前保存的快照是旋转前的，会导致尺寸错误
        this.step = -1;
        if (isAdd) this.rotateAngle += 90;
        else this.rotateAngle -= 90;
        this.even = ((this.rotateAngle / 90) % 2) === 0;
        let canvas = document.getElementById('myCanvas');
        let context = canvas.getContext('2d');

        let img, imgSrc;
        this.canvasHistory = [];
        // if (this.step === -1) {
        //     imgSrc = this.props.imgUrl;
        // } else if (this.canvasHistory.length >= 1) {
        //     // this.canvasHistory.length = this.step + 1;
        //     imgSrc = this.canvasHistory[this.step];
        // } else {
        //     imgSrc = this.props.imgUrl;
        // }
        // 已暂存的图片地址是base64，不需要拼接参数v，https旋转会有跨域，要拼接参数v
        imgSrc = this.props.imgUrl.includes('base64') && this.props.imgUrl || this.props.imgUrl+'?v=' + Math.random();
        img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.width = this.props.imgWidth * this.scale;
        img.height = this.props.imgHeight * this.scale;
        img.src = imgSrc;

        canvas.width = this.even ? img.width : img.height;
        canvas.height = this.even ? img.height : img.width;        
        
        this.setState({ imgLoading: true });
        img.onload = () => {
            this.setState({ imgLoading: false });
            context.translate(canvas.width / 2, canvas.height / 2);
            context.rotate(this.rotateAngle * Math.PI / 180);
            context.translate(-canvas.width / 2, -canvas.height / 2);
            context.drawImage(img, canvas.width / 2 - img.width / 2, canvas.height / 2 - img.height / 2, img.width, img.height);
            context.translate(canvas.width / 2, canvas.height / 2);
            context.rotate(-this.rotateAngle * Math.PI / 180);
            context.translate(-canvas.width / 2, -canvas.height / 2);
            context.restore();
        };
    }

    render() {
        return (
            <div className="canvasComponent-container">
                {
                    this.state.imgLoading && <div className="loading-container"><Spin size="large" /></div>
                }
                <div className="canvasMask"></div>
                <img alt="img" onClick={this.closeCanvasComponent} className="closeImg" src="data:image/svg+xml;base64,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" />
                <div className="canvasComponentWrapper">
                    <div className="control-ops">
                        <label style={{minWidth: '2em'}}>粗细</label>
                        <select className="mr9" id="selWidth" defaultValue="3">
                            <option value="1">1</option>
                            <option value="3">3</option>
                            <option value="5">5</option>
                            <option value="7">7</option>
                            <option value="9">9</option>
                            <option value="11">11</option>
                        </select>
                        <label style={{minWidth: '2em'}}>颜色</label>
                        <select className="mr9" id="selColor" defaultValue="red">
                            <option value="black">黑色</option>
                            <option value="blue">蓝色</option>
                            <option value="red">红色</option>
                            <option value="green">绿色</option>
                            <option value="yellow">黄色</option>
                            <option value="gray">灰色</option>
                        </select>
                        <label style={{minWidth: '2em'}}>字号</label>
                        <select className="mr9" id="selFont" defaultValue="18">
                            <option value="12">12</option>
                            <option value="14">14</option>
                            <option value="16">16</option>
                            <option value="18">18</option>
                            <option value="20">20</option>
                            <option value="22">22</option>
                            <option value="24">24</option>
                            <option value="26">26</option>
                            <option value="28">28</option>
                            <option value="30">30</option>
                            <option value="32">32</option>
                        </select>
                        <Button className="mr9" size="small" type="primary" onClick={this.undo}>撤销</Button>
                        <Button className="mr9" size="small" type="primary" onClick={this.redo}>取消撤销</Button>
                        <Button className="mr9" size="small" type="primary" onClick={() => this.rotateWrapper(false)}>左转</Button>
                        <Button className="mr9" size="small" type="primary" onClick={() => this.rotateWrapper(true)}>右转</Button>
                        <Button className="mr9" size="small" type="primary" onClick={()=>this.text()}>T文字</Button>
                        <Button className="mr9" size="small" type="primary" onClick={()=>this.text(true)}>画笔</Button>
                        <Button className="mr9" size="small" type="primary" onClick={this.uploadHandler}>暂存批注</Button>
                        {/* <Button type="primary" onClick={this.generatePic}>保存图片到本地</Button> */}

                    </div>
                    <div align="center" className="canvas-container" style={{'position':'relative'}}>
                        <canvas className="canvas" ref="canvasInstance" id="myCanvas" width={this.props.imgWidth * this.scale} height={this.props.imgHeight * this.scale}></canvas>
                    </div>
                </div>
            </div>
        )
    }
}

// CanvasComponent.propTypes = {
//     imgUrl: PropTypes.string,                           // 需要进行涂鸦的图片地址
//     upload: PropTypes.func,                             // 将图片上传到OSS的方法
//     showHoldImg: PropTypes.func,                       // 显示暂存批注的方法
//     hideCanvasComponent: PropTypes.func,                // 点击关闭按钮，隐藏CanvasComponent
//     imgWidth: PropTypes.number,                         // 所点击图片的原始宽度
//     imgHeight: PropTypes.number,                        // 所点击图片的原始高度
//     w2h: PropTypes.func,                                // 长变成高的方法
// };

export default CanvasComponent;
